import SkipNavigation from './SkipNavigation';

export default SkipNavigation;
